import pluralize from 'pluralize';

export const MEALS = {
  breakfast: 'Breakfast',
  morning_snack: 'Morning Snack',
  lunch: 'Lunch',
  afternoon_snack: 'Afternoon Snack',
  dinner: 'Dinner',
} as const;

export function getFullnessLevel(score: number): string {
  if (score === 0) return 'Totally empty, dizzy, nauseous';
  if (score === 1) return 'Very hungry';
  if (score >= 2 && score <= 3) return 'Hungry';
  if (score >= 4 && score <= 5) return 'Neutral';
  if (score >= 6 && score <= 7) return 'Satisfied';
  if (score >= 8 && score <= 10) return 'Very full';
  return '';
}

export function getMealLabel(mealKey: keyof typeof MEALS | string): string {
  return MEALS[mealKey as keyof typeof MEALS] || mealKey;
}

export function getUnitLabel(unit?: string): string {
  if (!unit) return '';
  return `${unit}(s)`;
}

export function formatServingSize(quantity: string, unit: string): string {
  const pluralizedUnit =
    quantity === '1' ? unit.toLowerCase() : pluralize(unit.toLowerCase());
  return `${quantity} ${pluralizedUnit}`;
}

export function sortMealOrder(
  a: { meal: string },
  b: { meal: string },
): number {
  return (
    Object.keys(MEALS).indexOf(a.meal) - Object.keys(MEALS).indexOf(b.meal)
  );
}
